// Lead status constants
export const LEAD_STATUS_NEW = "new";
export const LEAD_STATUS_INTERESTED = "interested";
export const LEAD_STATUS_TRIAL_SENT = "trial_sent";
export const LEAD_STATUS_NOT_INTERESTED = "not_interested";
export const LEAD_STATUS_NO_ANSWER = "no_answer";
export const LEAD_STATUS_OVERDUE = "overdue";
export const LEAD_STATUS_FOLLOW_UP = "follow_up";
export const LEAD_STATUS_READY = "ready";
export const LEAD_STATUS_ACTION_NEEDED = "action_needed";
export const LEAD_STATUS_MANUAL = "manual";
export const LEAD_STATUS_ALMOST_IN = "almost_in";

export const LEAD_STATUSES = [
  LEAD_STATUS_NEW,
  LEAD_STATUS_INTERESTED,
  LEAD_STATUS_TRIAL_SENT,
  LEAD_STATUS_NOT_INTERESTED,
  LEAD_STATUS_NO_ANSWER,
  LEAD_STATUS_FOLLOW_UP,
  LEAD_STATUS_OVERDUE,
  LEAD_STATUS_READY,
  LEAD_STATUS_ACTION_NEEDED,
  LEAD_STATUS_MANUAL,
  LEAD_STATUS_ALMOST_IN,
];

// Default status for new leads
export const LEAD_DEFAULT_STATUS = LEAD_STATUS_MANUAL;

export const LEAD_ORIGIN_FACEBOOK = "facebook";
export const LEAD_ORIGIN_INSTAGRAM = "instagram";
export const LEAD_ORIGIN_TIKTOK = "tiktok";
export const LEAD_ORIGIN_WEBSITE = "website";
export const LEAD_ORIGIN_AI_AGENT = "ai_agent";
export const LEAD_ORIGIN_SELF_ADDED = "self_added";
export const LEAD_ORIGIN_OTHER = "other";

export const LEAD_ORIGINS = [
  LEAD_ORIGIN_FACEBOOK,
  LEAD_ORIGIN_INSTAGRAM,
  LEAD_ORIGIN_OTHER,
  LEAD_ORIGIN_TIKTOK,
  LEAD_ORIGIN_WEBSITE,
  LEAD_ORIGIN_AI_AGENT,
  LEAD_ORIGIN_SELF_ADDED,
];
